import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OnboardingLayout from "../../layouts/OnboardingLayout/OnboardingLayout";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
import OtpField from "../../components/OtpField/OtpField";
import { Toaster, toast } from "react-hot-toast";
import ApiManager from "../../api/ApiManager";
import { useAuth } from "../../store/AuthContext/AuthContext";

const Verify = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otpCode, setOtpCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const api = new ApiManager();

  const { login } = useAuth();

  const user = location.state.userData;

  // Check if a resendTimer exists in localStorage and set it
  useEffect(() => {
    const savedTimer = parseInt(localStorage.getItem("resendTimer"));
    if (savedTimer && savedTimer > 0) {
      setResendTimer(savedTimer);
    }
  }, []);

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => {
        setResendTimer(resendTimer - 1);
        localStorage.setItem("resendTimer", resendTimer - 1); // Save updated timer to localStorage
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      // Clear localStorage when the timer reaches 0
      localStorage.removeItem("resendTimer");
    }
  }, [resendTimer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const handleOtpComplete = (code) => {
    setOtpCode(code);
  };

  const handleEmailResend = () => {
    if (resendTimer > 0) return;

    setLoading(true);
    api
      .post("/resend-verification", { email: user.email })
      .then(() => {
        toast.success("Nuovo codice inviato.");
        setResendTimer(60);
        localStorage.setItem("resendTimer", 60); // Save the timer when the resend button is clicked
      })
      .catch((error) => {
        toast.error(error.response.data.Message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    if (otpCode.length !== 6) return;

    setLoading(true);

    api
      .post("/verify", { code: otpCode, email: user.email })
      .then((res) => {
        //login(user);
        navigate("/login-form");
      })
      .catch((error) => {
        toast.error(error.response.data.Message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <OnboardingLayout hasProgress={false}>
      <Toaster />
      <div className="h-full pt-12 md:mx-auto md:w-[40rem] px-4 flex flex-col gap-9 md:gap-12 relative">
        <div className="flex flex-col gap-2 md:gap-4">
          <Typography
            align="center"
            family="serif"
            size="32"
            desktopSize="48"
            weight="sb"
            color="black"
          >
            Verifica la tua email
          </Typography>
          <Typography align="center" size="16" weight="md" color="gray-600">
            Controlla il codice a 6 cifre inviato via mail a
            <span className="text-black ml-1">{user.email}</span>
          </Typography>
        </div>
        <OtpField length={6} onComplete={handleOtpComplete} />
        <div className="flex flex-col gap-6">
          <Button
            onClick={handleSubmit}
            text={loading ? "Verifica..." : "Continua"}
            width="full"
            size={window.innerWidth >= 768 ? "lg" : "md"}
            type="color"
            disabled={otpCode.length < 6 || loading}
          />
          <div className="flex flex-col gap-3">
            <Typography align="center" size="16" color="gray-600">
              Non hai ricevuto l’email?
              <span className="mx-1">
                <Typography
                  align="center"
                  size="16"
                  color={
                    resendTimer > 0
                      ? "accent opacity-50 cursor-wait"
                      : "accent cursor-pointer"
                  }
                  weight="md"
                  underline={true}
                  onClick={handleEmailResend}
                >
                  Clicca qui
                </Typography>
              </span>
              per riceverla di nuovo.
            </Typography>
            {resendTimer > 0 && (
              <Typography align="center" size="16" color="gray-600">
                {formatTime(resendTimer)}
              </Typography>
            )}
          </div>
        </div>

        <img
          src="/assets/images/illustrations/new_email.png"
          alt="Starting Onboarding"
          className="fixed -bottom-16 md:-bottom-36 left-1/2 transform -translate-x-1/2 w-[18rem] md:w-[25rem] pointer-events-none"
        />
      </div>
    </OnboardingLayout>
  );
};

export default Verify;
